import { Link } from 'react-router-dom';
import LegalDoc from '../components/LegalDoc.jsx';
import { LEGAL } from '../data/legal.js';
import { CONTACT } from '../data/contact.js';

export default function PrivacyPage() {
  return (
    <LegalDoc
      intro={`This policy explains what information ${LEGAL.business} ("ProScape," "we," "us") collects when you visit this website or contact us about landscaping work, how we use it, and the choices you have.`}
      contactLead="If you have questions about this Privacy Policy, or you want to know what information we hold about you, reach us here:"
    >
      <h2>1. Who this policy covers</h2>
      <p>
        This policy applies to this website and to the information you share with us when you call, text,
        or message us about a quote or a job. It does not cover other companies' websites or services that
        we link to, including Facebook.
      </p>

      <h2>2. Information we collect</h2>
      <h3>Information you give us</h3>
      <p>
        This website has no contact form, no accounts, and no online payments. We only receive what you
        choose to send us when you get in touch — typically your name, phone number, the address of the
        property, and details about the work you want done. If you send photos or notes about your
        property, we receive those too.
      </p>
      <h3>Information collected automatically</h3>
      <p>
        Like most websites, the service that hosts this site keeps standard server logs of requests —
        things like IP address, browser type, the pages requested, and the date and time. These logs are
        used to keep the site running and secure. We do not use them to build advertising profiles.
      </p>
      <h3>Information we do not collect here</h3>
      <p>
        We do not collect payment card numbers, Social Security numbers, or other sensitive personal
        information through this website.
      </p>

      <h2>3. Cookies, fonts, and tracking</h2>
      <p>
        This website does not set advertising or analytics cookies of its own. Your browser may cache
        images and files so pages load faster. The site loads its fonts from Google Fonts, which means
        Google's servers receive your IP address and browser information when a page loads; that request
        is governed by Google's own privacy policy.
      </p>

      <h2>4. How we use your information</h2>
      <ul>
        <li>To respond to quote requests and answer questions.</li>
        <li>To schedule visits, plan the work, and perform the services you ask for.</li>
        <li>To send estimates and invoices, and to keep normal business and tax records.</li>
        <li>To follow up about a job, seasonal work, or an issue on your property.</li>
        <li>To operate, secure, and improve this website.</li>
        <li>To comply with the law, or to establish or defend legal claims.</li>
      </ul>

      <h2>5. How we share information</h2>
      <p>
        <strong>We do not sell or rent your personal information.</strong> We share it only in these
        limited situations:
      </p>
      <ul>
        <li>
          <strong>Service providers.</strong> Companies that help us operate — for example our web host,
          phone provider, or bookkeeping and invoicing tools — receive only what they need to provide
          that service.
        </li>
        <li>
          <strong>Crew and subcontractors.</strong> If part of a job is performed with help, the people
          doing the work may receive your address and job details.
        </li>
        <li>
          <strong>Facebook / Meta.</strong> If you message us through our Facebook page, that conversation
          happens on Meta's platform and is subject to Meta's privacy policy as well as this one.
        </li>
        <li>
          <strong>Legal reasons.</strong> If required by law, subpoena, or to protect the rights, property,
          or safety of ProScape, our customers, or others.
        </li>
        <li>
          <strong>Business transfer.</strong> If the business is sold or reorganized, customer records may
          transfer as part of that transaction.
        </li>
      </ul>

      <h2>6. Third-party links</h2>
      <p>
        This site links to our Facebook page and may link to other outside sites. We do not control those
        services and are not responsible for their content or privacy practices. Review their policies
        before sharing information with them.
      </p>

      <h2>7. How long we keep information</h2>
      <p>
        We keep quote and job records for as long as needed to serve you and to meet business, insurance,
        warranty, and tax requirements, then dispose of them. Casual inquiries that don't turn into work
        are kept only as long as they're useful.
      </p>

      <h2>8. Security</h2>
      <p>
        We take reasonable steps to protect the information we hold. No website, phone system, or
        messaging service is completely secure, so we can't guarantee absolute security. Please don't send
        us sensitive information such as card numbers or government ID numbers by text or social media
        message.
      </p>

      <h2>9. Your choices and rights</h2>
      <p>
        You can ask us what information we have about you, ask us to correct it, or ask us to delete it —
        except where we need to keep records for tax, warranty, insurance, or legal reasons. You can also
        ask us to stop contacting you at any time; just tell us by phone or message. Depending on where
        you live, including for residents of {LEGAL.governingState}, you may have additional rights under
        state law. Contact us using the details below and we'll respond within a reasonable time.
      </p>

      <h2>10. Children's privacy</h2>
      <p>
        This website is meant for adults arranging services for a property. It is not directed to children
        under 13, and we do not knowingly collect personal information from children. If you believe a
        child has sent us personal information, contact us and we will delete it.
      </p>

      <h2>11. Changes to this policy</h2>
      <p>
        We may update this policy as the business or the website changes. The "last updated" date at the
        top of this page shows when it last changed, and the current version is always posted here.
      </p>

      <h2>12. Related terms</h2>
      <p>
        Your use of this website is also governed by our <Link to="/terms">Terms of Service</Link>. To
        reach us about a quote instead, see the <Link to="/contact">contact page</Link> or call{' '}
        <a href={`tel:${CONTACT.phoneTel}`}>{CONTACT.phoneDisplay}</a>.
      </p>
    </LegalDoc>
  );
}
